import { ControlText } from '../typography';
import { MenuItemTextProps } from './menu-item-text-props';
import React from 'react';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'list-item-text';

/**
 * List component implementation before styling.
 */
export const MenuItemTextComponent = React.forwardRef<any, MenuItemTextProps>(
  (props, ref): React.ReactElement => {
    const { children, className, ...rest } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <ControlText {...componentProps}>{children}</ControlText>;
  },
);

MenuItemTextComponent.displayName = 'MenuItemText';

export const MenuItemText = styled(MenuItemTextComponent)`
  margin-top: 0;
`;
